
<div class="page-error-container" nz-flex nzJustify="center" nzAlign="center" nzVertical nzGap="1rem">
    <nz-icon nzType="tool" nzTheme="outline" />
    <h2>{{'ERRORS.NOT-FOUND' | translate}}</h2>
    <div class="back-home">
        <a routerLink="/">{{'GLOBAL.BACK-TO-HOME' | translate}}</a>
    </div>
</div>
